let Authenticator = null;

export const getAuthenticator = () => {
    return new Promise((resolve) => {
        if (Authenticator) {
            resolve(Authenticator);
        }

        return import(/* webpackChunkName: "authenticator" */ './Authenticator')
            .then(({default: mod}) => {
                Authenticator = mod;
                resolve(Authenticator);
            });
    });
};
